import {
  Alert,
  Modal,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { globalStyles } from "../styles/globalStyles";
import { MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { useContext, useEffect, useState } from "react";
import { API } from "aws-amplify";
import { getCommunity, listCommunities } from "../src/graphql/queries";
import { FlatList } from "react-native-gesture-handler";
import { UserContext } from "../globalData/UserContext";
import { CommunityContext } from "../globalData/ComunityContext";
import { ComNavContext } from "../globalData/ComNavContext";
import { createUserCommunities } from "../src/graphql/mutations";

export default function JoinCommunity({
  modalOpen,
  setModalOpen,
  nav,
  refresh,
}) {
  const [communities, setCommunities] = useState([]);
  const user = useContext(UserContext);
  const communityData = useContext(CommunityContext);
  const communityNavigation = useContext(ComNavContext);

  useEffect(() => {
    fetchAllCommunities();
  }, [modalOpen]);

  async function fetchAllCommunities() {
    const allComms = await API.graphql({ query: listCommunities });
    const comms = allComms.data.listCommunities.items;
    // comms.map((com) => {
    //   console.log(com.public);
    // });
    const publicComms = comms.filter((com) => com.public || com.public == null);
    setCommunities(publicComms);
  }

  async function getComUsers(com) {
    const userComs = com.users.items;
    const users = await Promise.all(
      userComs.map(async (user) => {
        return API.graphql({
          query: getUsers,
          variables: { uId: user.usersCommunitiesUId },
        });
      })
    );
  }

  async function joinCommunityHandler(com) {
    if (validCommunity(com)) {
      await createUCom(com);
      const updateCom = await API.graphql({
        query: getCommunity,
        variables: { cId: com.cId },
      });
      setModalOpen(false);
      communityData.updateCommunity(updateCom.data.getCommunity);
      nav.navigate("Drawer");
      communityNavigation.setCommunityNav(nav);
      refresh();
    } else Alert.alert("You are already in this community!");
  }

  function validCommunity(com) {
    let valid = true;
    const userComs = user.user.data.getUsers.communities.items;
    userComs.map((userCom) => {
      if (userCom.communityUsersCId == com.cId) valid = false;
    });
    return valid;
  }

  async function createUCom(community) {
    try {
      await API.graphql({
        query: createUserCommunities,
        variables: {
          input: {
            communityUsersCId: community.cId,
            usersCommunitiesUId: user.user.data.getUsers.uId,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  return (
    <Modal visible={modalOpen} animationType="fade">
      <MaterialIcons
        name="close"
        size={30}
        style={styles.modalClose}
        onPress={() => setModalOpen(false)}
      />
      <LinearGradient
        colors={["#E2CFC2", "#A48578"]}
        style={{ flex: 1, alignItems: "center" }}
      >
        <Text style={globalStyles.titleText}>Join a current community!</Text>
        <FlatList
          centerContent={true}
          directionalLockEnabled={true}
          numColumns={2}
          data={communities}
          renderItem={({ item }) => (
            <TouchableOpacity
              onPress={() => {
                if (Platform.OS != "web") {
                  Alert.alert(
                    "Join community?",
                    "Would you like to join community: " + item.cName + "?",
                    [
                      { text: "No" },
                      {
                        text: "Yes",
                        onPress: async () => {
                          await joinCommunityHandler(item);
                        },
                      },
                    ]
                  );
                } else {
                  joinCommunityHandler(item);
                }
              }}
            >
              <View style={{ flex: 1 }}>
                <View style={styles.card}>
                  <Text
                    style={{
                      ...globalStyles.subtitleText,
                      color: "#E2CFC2",
                      fontFamily: "quicksand-bold",
                    }}
                  >
                    {item.cName}
                  </Text>
                  <Text
                    style={{
                      ...globalStyles.paragraph,
                      fontFamily: "quicksand-bold",
                    }}
                  >
                    {item.city != null
                      ? "location: " + item.city
                      : "no location provided"}
                  </Text>
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      </LinearGradient>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalClose: {
    paddingTop: 40,
    paddingLeft: 20,
    paddingBottom: 10,
    color: "#492C1D",
    paddingHorizontal: 10,
    backgroundColor: "#E2CFC2",
  },
  card: {
    backgroundColor: "#f2f6fa",
    shadowOffset: { width: 1, height: 1 }, //shadow of the component; how much to the right and how much down
    shadowColor: "#333",
    shadowOpacity: 0.3, // how visible it is; 0 --> invisible, 1 --> dark
    shadowRadius: 2, // how it blends in as it goes further away from the card
    marginHorizontal: 10, // distance away from the horizontals
    marginVertical: 10,
    height: 100,
    width: 180,
    backgroundColor: "#997562",
    borderRadius: 20,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});
